import React from "react";

export default function SiteFooter() {
  return (
    <footer style={{borderTop:"1px solid #e5e7eb", marginTop:32, background:"#fff"}}>
      <div style={{maxWidth:1100, margin:"0 auto", padding:"20px 16px", color:"#475569", fontSize:14}}>
        <div style={{display:"flex", gap:20, flexWrap:"wrap", justifyContent:"space-between"}}>
          <div>
            <div style={{fontWeight:700, color:"#0f172a"}}>YogaPay</div>
            <div>Simple registration & payments for your yoga programs.</div>
          </div>
          <div>
            <div>© {new Date().getFullYear()} YogaPay • All rights reserved</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
